"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotjarTracker = void 0;
var _cookie = require("@rentspree/cookie");
var _debug = _interopRequireDefault(require("debug"));
var _window = require("../utils/window");
var _base = require("./base");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var debug = (0, _debug.default)('rentspree-tracker:hotjar');

/**
 * The class for HotjarTracker tracker
 */
var HotjarTracker = exports.HotjarTracker = /*#__PURE__*/function (_BaseTracker) {
  _inherits(HotjarTracker, _BaseTracker);
  function HotjarTracker() {
    var _this;
    _classCallCheck(this, HotjarTracker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HotjarTracker, [].concat(args));
    _this.hjSessionKeyName = '_hjid';
    return _this;
  }

  /**
   * Static method for getting the tracker from window
   * @returns {Object | Proxy} the hj object, if the function is not existed in `window.hj`,
   * this method will return Proxy to avoid error
   * @static
   */
  _createClass(HotjarTracker, [{
    key: "identifyUser",
    value:
    /**
     * send the identity of this user to HotjarTracker
     * - the identity of the user is the return from `options.mapUserIdentity(profile)`
     * - the user detail is the return from `options.mapUserProfile(profile)`
     * @param {Object} profile the user object
     */
    function identifyUser(profile) {
      // For UserID Tracking view
      debug('=== Hotjar identifyUser running... ===');
      debug('user data %o => ', profile);
      var identity = this.mapUserIdentity(profile);
      var attribute = this.mapUserProfile(profile);
      debug('hj(identify, %s, %o)', identity, attribute);
      HotjarTracker.getTracker()('identify', identity, attribute);
      debug('=== Hotjar identifyUser finished... ===');
    }

    /**
     * This method is removing Hotjar session with Local Storage and Cookie
     * for getting a newer Hotjar session for recording correct a new user logged in
     */
  }, {
    key: "logout",
    value: function logout() {
      debug('=== Hotjar logout running... ===');
      debug('Remove local storage and cookie with: %s', this.hjSessionKeyName);
      (0, _window.removeLocalStorageItem)(this.hjSessionKeyName);
      (0, _cookie.removeLocalItem)(this.hjSessionKeyName);
      debug('=== Hotjar logout finished... ===');
    }
  }], [{
    key: "getTracker",
    value: function getTracker() {
      if (window.hj) {
        return window.hj;
      }
      debug('warning! Seems like window.hj is not defined');
      return function () {};
    }
  }]);
  return HotjarTracker;
}(_base.BaseTracker);